import { type ConfigContextState } from 'app/common/ConfigContext';
import { getThemeName } from 'app/common/ThemeContext/utils';
import { getBackendUrl } from 'app/utils/api_url';
import { ERROR_TO_FILTER, ERROR_UNKNOWN } from 'app/constants/errors';

interface WidgetDisplayMetricsDataState {
  blocksCorrectlyLoaded: Block[];
  blocksFailed: Block[];
  widgetState: 'DISPLAYED' | 'ERROR' | 'NOT_FOUND' | 'INTEGRATION_ERROR' | undefined;
}

// URL
const getWidgetDisplayMetricsUrl = () => {
  const backendUrl = getBackendUrl();
  if (!backendUrl) {
    return undefined;
  }

  return `${backendUrl}/auth`;
};

// Params from ConfigContext
const getWidgetDisplayMetricsParams = (config: ConfigContextState | undefined) => {
  if (!config) {
    return {
      block: [] as Block[],
      tab: [] as Tab[]
    };
  }

  const { user, ...restParams } = config;
  const paramsToSend = {
    ...restParams,
    theme: getThemeName({ user })
  };

  return paramsToSend;
};

// Widget State
const getWidgetDisplayMetricsDataState = (
  data: ComposedEntityData | undefined,
  error: ErrorType | 'INTEGRATION_ERROR' | null | undefined
): WidgetDisplayMetricsDataState | undefined => {
  const blocksCorrectlyLoaded: Block[] = [];
  const blocksFailed: Block[] = [];
  let widgetState: WidgetDisplayMetricsDataState['widgetState'];

  if (error) {
    widgetState = error === ERROR_UNKNOWN ? 'ERROR' : error;
  } else if (data) {
    widgetState = 'DISPLAYED';
    Object.entries(data).forEach(([block, blockData]) => {
      // Because typescript doesn't infer key type in Object.entries()
      const typeInferedBlock = block as Block;
      if (blockData instanceof Error) {
        if (blockData.message !== ERROR_TO_FILTER) {
          blocksFailed.push(typeInferedBlock);
        }
      } else if (blockData !== null) {
        blocksCorrectlyLoaded.push(typeInferedBlock);
      }
    });
  }

  return { blocksCorrectlyLoaded, blocksFailed, widgetState };
};

export {
  getWidgetDisplayMetricsUrl,
  getWidgetDisplayMetricsParams,
  getWidgetDisplayMetricsDataState
};
